import {
  PERMISSION_ENTITY_INVOICE,
  PERMISSION_ENTITY_PROOF_OF_ACCEPTANCE,
  PERMISSION_ENTITY_PURCHASE_ORDER
} from '@klear/constants'

export const DOCUMENT_TYPE_UNCLASSIFIED = 'unclassified'

export const DECLARABLE_DOCUMENT_TYPES = [
  DOCUMENT_TYPE_UNCLASSIFIED,
  'purchase_order',
  'invoice',
  'proof_of_acceptance',
  'financial_statement',
  'other'
] as const

export const DOCUMENT_TYPES = [...DECLARABLE_DOCUMENT_TYPES, 'non_document'] as const
export type DocumentType = (typeof DOCUMENT_TYPES)[number]

export const DOCUMENT_TYPE_LABEL: Record<DocumentType, string> = {
  [DOCUMENT_TYPE_UNCLASSIFIED]: 'Unclassified',
  purchase_order: 'Purchase order',
  invoice: 'Invoice',
  proof_of_acceptance: 'Proof of acceptance',
  financial_statement: 'Financial statement',
  other: 'Other',
  non_document: 'Not a document'
}

const DOCUMENT_TYPE_OF_ORDER_EVENT: Partial<Record<string, DocumentType>> = {
  [PERMISSION_ENTITY_PURCHASE_ORDER]: 'purchase_order',
  [PERMISSION_ENTITY_INVOICE]: 'invoice',
  [PERMISSION_ENTITY_PROOF_OF_ACCEPTANCE]: 'proof_of_acceptance'
}

export function documentTypeOfOrderEvent(orderEventType: string): DocumentType | undefined {
  return DOCUMENT_TYPE_OF_ORDER_EVENT[orderEventType]
}
